/* global axios */
import ApiClient from './ApiClient';

class CrmPropertiesApi extends ApiClient {
  constructor() {
    super('crm_properties', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new CrmPropertiesApi();
